import { render, staticRenderFns } from "./ChangePhoneNumberModal.vue?vue&type=template&id=5bbee0f8"
import script from "./ChangePhoneNumberModal.vue?vue&type=script&lang=js"
export * from "./ChangePhoneNumberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports